export class Weather {
  constructor(difference) {
    this.styleId = 1
    this.width = 250
    this.height = 50
    this.top = 10
    this.left = 10
    this.innerElement = "cxWeather"
    this.content = "天气"
    this.fontFamily = "sans-serif"
    this.lineHeight = 50
    this.fontSize = 18
    this.fontWeight = 600
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(255,255,255,1)"
    this.bgType = "自定义"
    this.fontStyle = "normal"
    this.rotate = 0
    this.showDayTemp = true
    this.temoJoinSymbol = "/" //温度之间的连接符号
    this.showNightTemp = true
    this.showCity = true
    this.showIcon = false
    this.showWeatherText = true
    this.wordWrap = true
    this.iconSize = 20 //天气图标的宽度
    this.iconStyle = 1 //图标风格
    this.spacing = 6
    this.showIconOrder = 1
    this.showCityOrder = 2
    this.showWeatherTextOrder = 3
    this.showTempOrder = 4
    this.usePageQuery = false //页面传参
    this.showSelectCity = false
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
export class HomeWeather {
  constructor(difference) {
    this.width = 250
    this.height = 36
    this.top = 10
    this.left = 10
    this.innerElement = "cxWeather"
    this.content = "天气"
    this.fontFamily = "sans-serif"
    this.lineHeight = 36
    this.fontSize = 18
    this.fontWeight = 400
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(51, 51, 51, 1)"
    this.bgType = "自定义"
    this.fontStyle = "normal"
    this.rotate = 0
    this.showDayTemp = true
    this.temoJoinSymbol = "/" //温度之间的连接符号
    this.showNightTemp = true
    this.showCity = true
    this.showIcon = false
    this.showWeatherText = true
    this.wordWrap = true
    this.iconSize = 20 //天气图标的宽度
    this.iconStyle = 1 //图标风格
    this.spacing = 6
    this.showIconOrder = 1
    this.showCityOrder = 2
    this.showWeatherTextOrder = 3
    this.showTempOrder = 4
    // this.animateSets = {
    //   animateType: 0,
    //   animateDirection: "无",
    //   animateDuration: 1.5,
    //   animateDelay: 0,
    //   hasDirection: false,
    //   animateTriggerNumType: "单次触发",
    //   animateClass: "",
    //   executionAnimateClass: ""
    // }
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
